import React, {FC} from "react"

import id from "@irati/utils/id"
import {Deal, UserSaving} from "@irati/types"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {H2, H3, Label} from "@irati/ui/src/Typography"
import DealSavingsTypes from "@irati/deals/types/enums/DealSavingsType"
import getCurrency from "@irati/deals/helpers/deals/currency"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"
import EarnPointsBadge from "../../EarnPointsBadge"
import OldAmount from "../../BoostedSaving/OldAmount"

interface Props {
  deal: Required<Deal>
  idNamespace?: string
  allowEarnPointsModal?: boolean
  small?: boolean
  isMobile?: boolean
}

const Amount: FC<Props> = (props) => {
  const {idNamespace, small, deal, allowEarnPointsModal, isMobile} = props
  const currency = getCurrency(deal)
  const {type, savings} = deal
  const {userSavings, boostedSavings} = savings as Required<UserSaving>
  const isCurrencySaving = userSavings?.type === DealSavingsTypes.CURRENCY

  const Heading = small ? H3 : H2

  const header =
    type === DEAL_TYPE_COMPANY_BENEFITS ? (
      <FormattedMessage id="perks.components.importantInfoBlock.importantInfoBlock.save" />
    ) : (
      userSavings.header
    )

  return (
    <>
      <EarnPointsBadge deal={deal} hasModal={allowEarnPointsModal && !isMobile} />
      <div id={id("savings-blocks", idNamespace)}>
        <Label id={id("savings-header", idNamespace)} color="contrast" display="block" margin={0} textAlign="right">
          {header}
        </Label>
        <Heading id={id("saving-amount", idNamespace)} data-test="value">
          {userSavings.type === DealSavingsTypes.PERCENTAGE ? (
            `${userSavings.value}%`
          ) : (
            <FormattedCurrency isCents={false} value={userSavings.value} currency={currency} />
          )}
        </Heading>
      </div>
      {!deal.earnPoints && <OldAmount value={boostedSavings?.oldSavings?.value} isCurrencySaving={isCurrencySaving} currency={currency} />}
    </>
  )
}

export default Amount
